import React from "react";
import T from "prop-types";

import PageMessage from "2g-page-message";

import { Cards } from "2g-cards";

import provozniInformaceType from "./provozniInformaceType";
import ProvozniInformaceCard from "./ProvozniInformaceCard";
import ProvozniInformacePlaceholder from "./ProvozniInformacePlaceholder";
import useMessages from "./i18n/useMessages";

function ProvozniInformaceCards({
  items,
  loading = false,
  onDeleteSuccess,
  editable,
  deletable,
  addOn
}) {
  const { cardsEmpty } = useMessages();
  return (
    <>
      {loading || items?.length > 0 ? (
        <Cards>
          {loading ? (
            <ProvozniInformacePlaceholder />
          ) : (
            <>
              {items.map(item => (
                <ProvozniInformaceCard
                  key={item.id}
                  data={item}
                  onDeleteSuccess={onDeleteSuccess}
                  editable={editable}
                  deletable={deletable}
                />
              ))}
              {addOn}
            </>
          )}
        </Cards>
      ) : (
        <PageMessage inline>{cardsEmpty()}</PageMessage>
      )}
    </>
  );
}

ProvozniInformaceCards.propTypes = {
  items: T.arrayOf(provozniInformaceType),
  loading: T.bool,
  onDeleteSuccess: T.func,
  editable: T.bool,
  deletable: T.bool,
  addOn: T.any
};

export default React.memo(ProvozniInformaceCards);
